import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { FormControl, Validators, FormBuilder, FormGroup, ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { TenantData, Tenant } from '../../../@core/interfaces/masters/tenant';
import { environment } from '../../../../environments/environment';
import { CountryData, CountryMst } from '../../../@core/interfaces/masters/country';
import { DistrictData } from '../../../@core/interfaces/masters/district';
import { StateData, StateMst } from '../../../@core/interfaces/masters/state';
import { INgxSelectOption } from 'ngx-select-ex';
import { imageatch_det, imageatch_detData } from '../../../@core/interfaces/masters/imageatch_det';
import { TenantPackageData } from '../../../@core/interfaces/masters/tenantpackage';
import { PackageController, PackageControllerData } from '../../../@core/interfaces/masters/packagecontroller';
import { CookieService } from '../../../@theme/components/common/service/cookies.service';
import { SettingService } from '../../../@theme/components/common/service/settings.service';
@Component({
  selector: 'ngx-tenant-list',
  templateUrl: './tenant-list.component.html',
  styleUrls: ['./tenant-list.component.css']
})
export class TenantListComponent implements OnInit {

  private tenantId = localStorage.getItem("tenantId");
  private branchId = localStorage.getItem("branchId");
  protected readonly unsubscribe$ = new Subject<void>();
  data: Tenant[];
  p: number = 1;
  placeholder: string = "Select";
  @Output() dataEvent: EventEmitter<any> = new EventEmitter<any>();
  allowClear: any = true;
  multiple: boolean = false;
  multiplePackage: boolean = true;
  isSubmitted: boolean = false;
  stateData: any;
  loadStateData: any;
  countryData: any;
  loadDistrictData: any;
  districtData: any;
  countriesList: CountryMst[];
  statesList: StateMst[];
  loadstatesList: StateMst[];
  tenantEditForm: FormGroup;
  editTenantDetails: Tenant;
  editTenantData: Tenant;
  newTenantData: Tenant;
  newtenantName: any;
  newContNum: string;
  newGender: string;
  newDOB: string;
  newBldGrp: string;
  newTimezon: string;
  newAddr: string;
  newCity: string;
  newState: string;
  newCtry: string;
  newPinCode: string;
  newAltPh: string;
  newLanKnown: string;
  newEmail: string;
  @Input() myPageData: any;
  @Input() listData: any;
  @Input() isCreate: any;
  @Input() isEdit: any;
  submitted: boolean = false;
  fileSizeError:boolean=false;
  isEditComponent: boolean = false;
  isAddComponent: boolean = false;
  fileToUpload: File = null;
  labfileToUpload: File = null;
  pharmacyfileToUpload: File = null;
  banner1fileToUpload: File = null;
  banner2fileToUpload: File = null;
  banner3fileToUpload: File = null;

  @ViewChild('myInput') myInputVariable: ElementRef;
  @ViewChild('mylabInput') mylabInputVariable: ElementRef;
  @ViewChild('mypharmacyInput') mypharmacyInputVariable: ElementRef;
  fromPage: any;
  isSuperAdmin: boolean = false;
  srcname: any = "../.././../../assets/images/logo.png";
  labsrcname: any = "../.././../../assets/images/logo.png";
  pharmacysrcname: any = "../.././../../assets/images/logo.png";
  bannersrcname1: any = "../.././../../assets/images/default_uploadimage.png";
  bannersrcname2: any = "../.././../../assets/images/default_uploadimage.png";
  bannersrcname3: any = "../.././../../assets/images/default_uploadimage.png";
  x: any;
  tenantPackageId: any;
  packageListDropDown: PackageController[];
  @Input() profiledata: Tenant;
  @Input() newTenantEdit: boolean;
  @Input() superAdmin: boolean;

  smsActivationFlag: boolean = false;
  whatsappActivationFlag: boolean = false;
  mailActivationFlag: boolean = false;
  tenantLogo: any;
  editfromSubscrip: boolean = false;
  editTenantId: string;
  errorMsg: boolean = false;
  constructor(private settingsService: SettingService,protected packageControllerSrvc: PackageControllerData, protected tenantpackageSrvc: TenantPackageData, protected stateSrvc: StateData, protected cntrySrvc: CountryData, protected districtSrvc: DistrictData, protected tenantSrvc: TenantData, private router: Router, private route: ActivatedRoute,
    private builder: FormBuilder, private iatchSrvc: imageatch_detData, private logoupdate: CookieService) {
    this.tenantEditForm = this.builder.group({

      newtenantName: new FormControl(null, [Validators.required, Validators.pattern(/^[a-zA-Z-.' ]+$/)]),
      mobile: new FormControl(null, [Validators.required, Validators.pattern('^[0-9-]+$')]),
      newAltPh: new FormControl(null, [Validators.pattern('^[0-9-]+$'), Validators.maxLength(20), Validators.minLength(9)]),
      contactName: new FormControl(null, [Validators.required, Validators.pattern('^[a-zA-Z-. ]+$')]),
      newEmail: new FormControl(null, [Validators.required, Validators.email]),
      area: new FormControl(null, []),
      streetname: new FormControl(null, []),
      city: new FormControl(null, [Validators.required, Validators.pattern('^[A-Za-z0-9]+$')]),
      state: new FormControl(null, []),
      district: new FormControl(null, []),
      country: new FormControl(null, [Validators.required]),
      tenantUserId: new FormControl(null, []),
      pincode: new FormControl(null, [Validators.required,Validators.pattern(/^[0-9]+$/)]),
      file: new FormControl(null,),
      packageId: new FormControl(null, []),
      isSameBillingAddress: new FormControl(null, []),

      billArea: new FormControl(null, []),
      billStreetname: new FormControl(null, []),
      billCity: new FormControl(null, [Validators.pattern('^[A-Za-z0-9]+$')]),
      billState: new FormControl(null, []),
      billDistrict: new FormControl(null, []),
      billCountry: new FormControl(null, []),
      billPincode: new FormControl(null, [Validators.pattern(/^[0-9]+$/)]),

      language: new FormControl(null, []),
      taxNum: new FormControl(null, []),
      taxStatus: new FormControl(null, []),
      CurrencyId: new FormControl(null, []),

      primaryName: new FormControl(null, [Validators.pattern('^[a-zA-Z-. ]+$')]),
      primaryRole: new FormControl(null, [Validators.pattern('^[a-zA-Z-. ]+$')]),
      primaryemail: new FormControl(null, [Validators.email]),
      primaryMobile: new FormControl(null, [Validators.pattern('^[0-9-]+$')]),

      primaryName1: new FormControl(null, [Validators.pattern('^[a-zA-Z-. ]+$')]),
      primaryRole1: new FormControl(null, [Validators.pattern('^[a-zA-Z-. ]+$')]),
      primaryemail1: new FormControl(null, [Validators.email]),
      primaryMobile1: new FormControl(null, [Validators.pattern('^[0-9-]+$')]),

      hidePoweredByContent: new FormControl(null),
      // sourceUrl: new FormControl(null, []),
    }, { validators: mobileAndAltMobileValidator("mobile", "newAltPh") });
        this.tenantEditForm.get('country')?.valueChanges.subscribe((code) => {
    this.updateMobileNumberValidation(code);});
        this.tenantEditForm.get('billCountry')?.valueChanges.subscribe((code) => {
    this.updateMobileandPincodeValidation(code);});
  }

  ngOnInit(): void {
    this.loadGeo();
    this.getTenantPackageId();
    this.loadPackageController();


    if (this.listData != null && this.listData != undefined) {
      this.callEdit(this.listData)
    }
    else {
      this.isAddComponent = false;
      this.isEditComponent = false;
      this.fetchTenant();
    }
  }

    updateMobileandPincodeValidation(countryCode) {
      var code = this.countryData?.find(x=>x.id == countryCode)
      if(code != null && code != undefined && code){
      const { minPinLength, maxPinLength } = this.settingsService.getPinCodeMinMaxLength(code?.countryCode);
      const { minLength, maxLength } = this.settingsService.getMinMaxLength(code?.countryCode);
      this.tenantEditForm.get('billPincode')?.setValidators([Validators.pattern('^[0-9]+$'),
      Validators.minLength(minPinLength),
      Validators.maxLength(maxPinLength)
    ]);
        this.tenantEditForm.get('primaryMobile1')?.setValidators([  Validators.pattern('^[0-9]+$'),
        Validators.minLength(minLength),
        Validators.maxLength(maxLength)
      ]);
        this.tenantEditForm.get('primaryMobile')?.setValidators([ Validators.pattern('^[0-9]+$'),
        Validators.minLength(minLength),
        Validators.maxLength(maxLength)
      ]);
      } else { this.tenantEditForm.get('billPincode')?.setValidators([Validators.pattern('^[0-9]+$'),Validators.minLength(6),
      Validators.maxLength(6)]);}

      this.tenantEditForm.get('billPincode')?.updateValueAndValidity();
      this.tenantEditForm.get('primaryMobile1')?.updateValueAndValidity();
      this.tenantEditForm.get('primaryMobile')?.updateValueAndValidity();
    }

  updateMobileNumberValidation(countryCode) {
      var code = this.countryData?.find(x=>x.id == countryCode)
      if(code != null && code != undefined && code){
      const { minPinLength, maxPinLength } = this.settingsService.getPinCodeMinMaxLength(code?.countryCode);
      const { minLength, maxLength } = this.settingsService.getMinMaxLength(code?.countryCode);
      this.tenantEditForm.get('pincode')?.setValidators([Validators.pattern('^[0-9]+$'),Validators.required,
      Validators.minLength(minPinLength),
      Validators.maxLength(maxPinLength)
    ]);
        this.tenantEditForm.get('mobile')?.setValidators([ Validators.required, Validators.pattern('^[0-9]+$'),
        Validators.minLength(minLength),
        Validators.maxLength(maxLength)
      ]);
      } else { this.tenantEditForm.get('pincode')?.setValidators([Validators.required,Validators.pattern('^[0-9]+$'),Validators.minLength(6),
      Validators.maxLength(6)]);}

      this.tenantEditForm.get('pincode')?.updateValueAndValidity();
      this.tenantEditForm.get('mobile')?.updateValueAndValidity();
    }
  loadPackageController(): void {
    this.packageControllerSrvc.list().pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      this.packageListDropDown = data.value;
    }, (error) => {
    }, () => {

    });
  }
  getTenantPackageId() {
    this.tenantpackageSrvc.tenantList(`tenantPackage/GetTenantBranchDuplicate/${this.tenantId}/${this.branchId}`).pipe(takeUntil(this.unsubscribe$)).subscribe((tenPackage: any) => {
      this.tenantPackageId = tenPackage[0]?.packageId;
    }, (error) => {
    }, () => {
    });
  }

  trim(el, arg) {
    el = el.replace(/\s{2,}/g, ' ')
    this.tenantEditForm.controls[arg].setValue(el.trim());
  }

  communicationaddressclick() {
    let checkVal = this.tenantEditForm.get('isSameBillingAddress').value;
    if (checkVal == true) {
      this.tenantEditForm.controls["billStreetname"].setValue(this.tenantEditForm.get('streetname').value);
      this.tenantEditForm.controls["billArea"].setValue(this.tenantEditForm.get('area').value);
      this.tenantEditForm.controls["billPincode"].setValue(this.tenantEditForm.get('pincode').value);
      this.tenantEditForm.controls["billCity"].setValue(this.tenantEditForm.get('city').value);
      this.tenantEditForm.controls["billDistrict"].setValue(this.tenantEditForm.get('district').value);
      this.tenantEditForm.controls["billState"].setValue(this.tenantEditForm.get('state').value);
      this.tenantEditForm.controls["billCountry"].setValue(this.tenantEditForm.get('country').value);

    }
    else {
      this.tenantEditForm.controls["billStreetname"].setValue(null);
      this.tenantEditForm.controls["billArea"].setValue(null);
      this.tenantEditForm.controls["billPincode"].setValue(null);
      this.tenantEditForm.controls["billCity"].setValue(null);
      this.tenantEditForm.controls["billDistrict"].setValue(null);
      this.tenantEditForm.controls["billState"].setValue(null);
      this.tenantEditForm.controls["billCountry"].setValue(null);

    }
  }
  capitalize = (s, arg) => {

    s = s.charAt(0).toUpperCase() + s.slice(1);
    s = s.replace(/\s{2,}/g, ' ');

    this.tenantEditForm.controls[arg].setValue(s.trim());
  }
  onDistrictChge(event: INgxSelectOption[]): void {
    if (event != null && event.length > 0) {
      this.tenantEditForm.controls["country"].setValue(event[0].data.countryId);
      this.tenantEditForm.controls["state"].setValue(event[0].data.stateId);
    }
    else {
      return;
    }
  }
  get fval(): { [key: string]: AbstractControl } { return this.tenantEditForm.controls; }

  fetchTenant(): void {

    this.tenantSrvc.list(`${this.tenantId}/tenantmst`).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      this.data = data.value;
    }, (error) => {

    }, () => {

    });
  }
  storageProviderData:Number
  public callEdit(data: Tenant): void {
    this.isEditComponent = true;
    this.isAddComponent = false;
    this.editTenantDetails = data;
    if (this.editTenantDetails.isSuperAdmin == "true")
      this.isSuperAdmin = true;
    this.tenantEditForm.controls['hidePoweredByContent'].setValue(data.sourceUrl!=null?data.hideLabel:null);
    // this.tenantEditForm.controls['sourceUrl'].setValue(data.sourceUrl);

    this.tenantEditForm.controls['newtenantName'].setValue(data.name);
    this.tenantEditForm.controls['contactName'].setValue(data.contactName);
    this.tenantEditForm.controls['mobile'].setValue(data.phoneNum);
    this.tenantEditForm.controls['newEmail'].setValue(data.emailAddr);
    this.tenantEditForm.controls['area'].setValue(data.area);
    this.tenantEditForm.controls['streetname'].setValue(data.street);
    this.tenantEditForm.controls['city'].setValue(data.city);
    this.tenantEditForm.controls['district'].setValue(data.district);
    this.tenantEditForm.controls['state'].setValue(data.state);
    this.tenantEditForm.controls['country'].setValue(data.country);
    this.tenantEditForm.controls['pincode'].setValue(data.pincode);
    this.tenantEditForm.controls['newAltPh'].setValue(data.other_AddPHNO);
    this.tenantEditForm.controls['tenantUserId'].setValue(data.tenantUserId);

    this.tenantEditForm.controls['billArea'].setValue(data.bill_area);
    this.tenantEditForm.controls['billStreetname'].setValue(data.bill_street);
    this.tenantEditForm.controls['billCity'].setValue(data.bill_city);
    this.tenantEditForm.controls['billDistrict'].setValue(data.bill_district);
    this.tenantEditForm.controls['billState'].setValue(data.bill_state);
    this.tenantEditForm.controls['billCountry'].setValue(data.bill_country);
    this.tenantEditForm.controls['billPincode'].setValue(data.bill_pincode);

    this.tenantEditForm.controls['primaryName'].setValue(data.pri_name);
    this.tenantEditForm.controls['primaryRole'].setValue(data.primaryrole);
    this.tenantEditForm.controls['primaryemail'].setValue(data.pri_email);
    this.tenantEditForm.controls['primaryMobile'].setValue(data.primary_mobile);

    this.tenantEditForm.controls['primaryName1'].setValue(data.pri_name1);
    this.tenantEditForm.controls['primaryRole1'].setValue(data.primaryrole1);
    this.tenantEditForm.controls['primaryemail1'].setValue(data.pri_email1);
    this.tenantEditForm.controls['primaryMobile1'].setValue(data.primary_mobile1);
this.storageProviderData = data.storageProvider
    // For sms purpose:-
    if (data.smsActivationFlag == true) {
      this.smspurchaseYes();
    }
    else {
      this.smspurchaseNo();
    }

    // For whatsapp purpose:-
    if (data.whatsAppActivationFlag == true) {
      this.whatsapppurchaseYes();
    }
    else {
      this.whatsapppurchaseNo();
    }

    //For Mail purpose:-
    if (data.mailActivationFlag == true) {
      this.mailpurchaseYes();
    }
    else {
      this.mailpurchaseNo();
    }
    this.iatchSrvc.getById(`${environment.apiUrl}/ImageAtchDet/${this.tenantId}/${this.branchId}/all`).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      let lablogo;
      let pharmacylogo;
      let bannerlogo;
      this.x = data.filter(x => x.phyId == null && x.empId == null && x.patId == null && x.tenantId === this.tenantId && x.category == "logo")
      lablogo = data.filter(x => x.phyId == null && x.empId == null && x.patId == null && x.tenantId === this.tenantId && x.category == "Lab logo")
      pharmacylogo = data.filter(x => x.phyId == null && x.empId == null && x.patId == null && x.tenantId === this.tenantId && x.category == "Pharmacy logo")
      bannerlogo = data.filter(x => x.phyId == null && x.empId == null && x.patId == null && x.tenantId === this.tenantId && x.category == "wallpaper")

      this.srcname = "../.././../../assets/images/logo.png";
      this.labsrcname = "../.././../../assets/images/logo.png";
      this.pharmacysrcname = "../.././../../assets/images/logo.png";

      if (this.x.length > 0) {
        this.x[0].isCreate = true;
        this.x[0].isEdit = true;
        this.iatchSrvc.create(`${environment.apiUrl}/ImageAtchDet/${this.tenantId}/${this.branchId}/download`, this.x[0]).pipe(takeUntil(this.unsubscribe$)).subscribe((downloaddata: any) => {
          this.srcname = 'data:image/jpeg;base64,' + downloaddata;
          localStorage.setItem("logo", this.srcname);
          this.logoupdate.setlogo(this.srcname);

        }, (error) => {

        }, () => {

        });
      }

      if (lablogo.length > 0) {
        lablogo[0].isCreate = true;
        lablogo[0].isEdit = true;
        this.iatchSrvc.create(`${environment.apiUrl}/ImageAtchDet/${this.tenantId}/${this.branchId}/download`, lablogo[0]).pipe(takeUntil(this.unsubscribe$)).subscribe((downloaddata: any) => {
          this.labsrcname = 'data:image/jpeg;base64,' + downloaddata;
          localStorage.setItem("Lab logo", this.labsrcname);
        }, (error) => {

        }, () => {

        });
      }

      if (pharmacylogo.length > 0) {
        pharmacylogo[0].isCreate = true;
        pharmacylogo[0].isEdit = true;
        this.iatchSrvc.create(`${environment.apiUrl}/ImageAtchDet/${this.tenantId}/${this.branchId}/download`, pharmacylogo[0]).pipe(takeUntil(this.unsubscribe$)).subscribe((downloaddata: any) => {
          this.pharmacysrcname = 'data:image/jpeg;base64,' + downloaddata;
          localStorage.setItem("Pharmacy logo", this.pharmacysrcname);
        }, (error) => {

        }, () => {

        });
      }

      if (bannerlogo.length > 0) {
        bannerlogo[0].isCreate = true;
        bannerlogo[0].isEdit = true;
        this.iatchSrvc.create(`${environment.apiUrl}/ImageAtchDet/${this.tenantId}/${this.branchId}/download`, bannerlogo[0]).pipe(takeUntil(this.unsubscribe$)).subscribe((downloaddata: any) => {
          this.bannersrcname1 = 'data:image/jpeg;base64,' + downloaddata;
          localStorage.setItem("banner logo1", this.bannersrcname1);
        }, (error) => {

        }, () => {
        });

        if (bannerlogo[1] != null) {
          bannerlogo[1].isCreate = true;
          bannerlogo[1].isEdit = true;
          this.iatchSrvc.create(`${environment.apiUrl}/ImageAtchDet/${this.tenantId}/${this.branchId}/download`, bannerlogo[1]).pipe(takeUntil(this.unsubscribe$)).subscribe((downloaddata: any) => {
            this.bannersrcname2 = 'data:image/jpeg;base64,' + downloaddata;
            localStorage.setItem("banner logo2", this.bannersrcname2);
          }, (error) => {

          }, () => {
          });
        }

        if (bannerlogo[2] != null) {
          bannerlogo[2].isCreate = true;
          bannerlogo[2].isEdit = true;
          this.iatchSrvc.create(`${environment.apiUrl}/ImageAtchDet/${this.tenantId}/${this.branchId}/download`, bannerlogo[2]).pipe(takeUntil(this.unsubscribe$)).subscribe((downloaddata: any) => {
            this.bannersrcname3 = 'data:image/jpeg;base64,' + downloaddata;
            localStorage.setItem("banner logo3", this.bannersrcname3);
          }, (error) => {

          }, () => {
          });
        }
      }


    }, (error) => {

    }, () => {

    });

  }

  loadGeo(): void {
    this.cntrySrvc.list().pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      this.countryData = data.value;
      this.settingsService.setCountryData(data.value);
      this.stateSrvc.list().pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
        this.stateData = data.value;
        this.loadStateData = data.value;
        this.districtSrvc.list().pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
          this.districtData = data;
          this.loadDistrictData = this.districtData;

        }, (error) => {

        }, () => {

        });

      }, (error) => {

      }, () => {

      });
    }, (error) => {

    }, () => {

    });
  }
  callAdd(): void {
    this.router.navigate(['/pages/masters/newtenant']);
  }

  test(data) {
    this.editfromSubscrip = true;
    this.profiledata = data;
    this.onEdit();
  }

  onEdit(): void {
    if (this.editfromSubscrip == true && this.profiledata != null && this.profiledata != undefined) {
      this.editTenantData = this.profiledata;
      this.editTenantId = this.profiledata.id
    }
    else if (this.tenantEditForm.valid) {
      this.editTenantId = this.editTenantDetails.id
      this.editTenantData = {
        name: this.tenantEditForm.get('newtenantName').value,
        contactName: this.tenantEditForm.get('contactName').value,
        phoneNum: this.tenantEditForm.get('mobile').value,
        emailAddr: this.tenantEditForm.get('newEmail').value,
        area: this.tenantEditForm.get('area').value,
        street: this.tenantEditForm.get('streetname').value,
        city: this.tenantEditForm.get('city').value,
        district: this.tenantEditForm.get('district').value,
        state: this.tenantEditForm.get('state').value,
        country: this.tenantEditForm.get('country').value,
        pincode: this.tenantEditForm.get('pincode').value,
        other_AddPHNO: this.tenantEditForm.get('newAltPh').value,
        tenantUserId: this.tenantEditForm.get('tenantUserId').value,
        emailVerification: this.editTenantDetails.emailVerification,
        mobileVerification: this.editTenantDetails.mobileVerification,

        bill_street: this.tenantEditForm.get('billStreetname').value,
        bill_city: this.tenantEditForm.get('billCity').value,
        bill_district: this.tenantEditForm.get('billDistrict').value,
        bill_state: this.tenantEditForm.get('billState').value,
        bill_country: this.tenantEditForm.get('billCountry').value,
        bill_pincode: this.tenantEditForm.get('billPincode').value,
        bill_area: this.tenantEditForm.get('billArea').value,

        // From Subscription : Anandhi 
        noOfBranch: this.editTenantDetails.noOfBranch,
        noOfLicences: this.editTenantDetails.noOfLicences,
        languageId: this.editTenantDetails.languageId,
        CurrencyId: this.editTenantDetails.CurrencyId,
        taxStatus: this.editTenantDetails.taxStatus,
        taxNum: this.editTenantDetails.taxNum,

        pri_name1: this.tenantEditForm.get('primaryName1').value,
        primaryrole1: this.tenantEditForm.get('primaryRole1').value,
        pri_email1: this.tenantEditForm.get('primaryemail1').value,
        primary_mobile1: this.tenantEditForm.get('primaryMobile1').value,

        pri_name: this.tenantEditForm.get('primaryName').value,
        primaryrole: this.tenantEditForm.get('primaryRole').value,
        pri_email: this.tenantEditForm.get('primaryemail').value,
        primary_mobile: this.tenantEditForm.get('primaryMobile').value,
        smsActivationFlag: this.smsActivationFlag,
        whatsAppActivationFlag: this.whatsappActivationFlag,
        mailActivationFlag: this.mailActivationFlag,
        subcriptionType: this.editTenantDetails.subcriptionType,
        
        sourceUrl: this.editTenantDetails?.sourceUrl,
        hideLabel: this.tenantEditForm.get('hidePoweredByContent').value,
        storageProvider:this.storageProviderData,
         controlCenter:this.editTenantDetails?.controlCenter,
          superAdminController:this.editTenantDetails?.superAdminController,
          tenantCountryCode: this.editTenantDetails?.tenantCountryCode,
      };
    }
    else {
      this.errorMsg = true;
        setTimeout(() => {
          this.errorMsg = false;
        }, 5000);
    }

    if (this.editTenantData != null && this.editTenantData != undefined) {
      this.tenantSrvc.update(`${this.apiUrl}/tenants/${this.editTenantId}/tenantmst/${this.editTenantId}`, this.editTenantData).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {

        this.iatchSrvc.getById(`${environment.apiUrl}/ImageAtchDet/${this.tenantId}/${this.branchId}/all`).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {

          this.x = data.filter(x => x.phyId == null && x.empId == null && x.patId == null && x.tenantId === this.tenantId && x.category == "logo")
          if (this.x.length > 0) {
            if (this.fileToUpload != null) {
              const formData: FormData = new FormData();
              formData.set('fileKey', this.fileToUpload, this.tenantId + "." + this.fileToUpload.name.substring(this.fileToUpload.name.lastIndexOf('.') + 1));

              let postData: imageatch_det = {
                id:this.x[0].id,
                tenantId: this.tenantId,
                branchId: this.branchId,
                containerName: this.tenantId,
                fileLocation: `${this.branchId}/logo/${this.tenantId + "." + this.fileToUpload.name.substring(this.fileToUpload.name.lastIndexOf('.') + 1)}`,
                fileName: this.tenantId + "." + this.fileToUpload.name.substring(this.fileToUpload.name.lastIndexOf('.') + 1),
                category: "logo",
                createdDate: this.x[0].createdDate,
                createdBy: localStorage.getItem("userId"),
                isCreate: true,
                isEdit: true,
                isView: true,
              }

              for (const prop in postData) {
                if (!postData.hasOwnProperty(prop)) { continue; }
                formData.append(prop, postData[prop]);
              }
              this.iatchSrvc.update(`${environment.apiUrl}/ImageAtchDet/${this.tenantId}/${this.branchId}/${this.x[0].id}`, formData).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {

                this.myInputVariable.nativeElement.value = "";
                this.fileToUpload = null;
              }, (error) => {

              }, () => {
                localStorage.setItem("TenantHospitalImg", this.tenantLogo);
                localStorage.setItem("logo", this.tenantLogo);
                this.logoupdate.setlogo(this.tenantLogo);
              });

            }
          }
          else {
            if (this.fileToUpload != null && this.fileToUpload != undefined) {
              const formData: FormData = new FormData();

              formData.set('fileKey', this.fileToUpload, this.tenantId + "." + this.fileToUpload.name.substring(this.fileToUpload.name.lastIndexOf('.') + 1));

              let postData: imageatch_det = {
                tenantId: this.tenantId,
                branchId: this.branchId,
                containerName: this.tenantId,
                fileLocation: `${this.tenantId}/${this.branchId}/logo/${this.tenantId + "." + this.fileToUpload.name.substring(this.fileToUpload.name.lastIndexOf('.') + 1)}`,
                fileName: this.tenantId + "." + this.fileToUpload.name.substring(this.fileToUpload.name.lastIndexOf('.') + 1),
                category: "logo",
                createdDate: new Date(),
                createdBy: localStorage.getItem("userId"),
                isCreate: true,
                isEdit: true,
                isView: true,

              }

              for (const prop in postData) {
                if (!postData.hasOwnProperty(prop)) { continue; }
                formData.append(prop, postData[prop]);
              }

              this.iatchSrvc.create(`${this.getApiUrl}/ImageAtchDet/${this.tenantId}/${this.branchId}/atch`, formData).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
                this.myInputVariable.nativeElement.value = "";
                this.fileToUpload = null;
              }, (error) => {
              }, () => {
                localStorage.setItem("TenantHospitalImg", this.tenantLogo);
                localStorage.setItem("logo", this.tenantLogo);
                this.logoupdate.setlogo(this.tenantLogo);
              });

            }
          }

          let labresult = data.filter(x => x.phyId == null && x.empId == null && x.patId == null && x.tenantId === this.tenantId && x.category == "Lab logo")
          if (labresult.length > 0) {
            if (this.labfileToUpload != null) {
              const formData: FormData = new FormData();
              formData.set('fileKey', this.labfileToUpload, this.tenantId + "." + this.labfileToUpload.name.substring(this.labfileToUpload.name.lastIndexOf('.') + 1));
              let postData: imageatch_det = {
                id:labresult[0].id,
                tenantId: this.tenantId,
                branchId: this.branchId,
                containerName: this.tenantId,
                fileLocation: `${this.branchId}/Lab logo/${this.tenantId + "." + this.labfileToUpload.name.substring(this.labfileToUpload.name.lastIndexOf('.') + 1)}`,
                fileName: this.tenantId + "." + this.labfileToUpload.name.substring(this.labfileToUpload.name.lastIndexOf('.') + 1),
                category: "Lab logo",
                createdDate: labresult[0].createdDate,
                createdBy: localStorage.getItem("userId"),
                isCreate: true,
                isEdit: true,
                isView: true,


              }

              for (const prop in postData) {
                if (!postData.hasOwnProperty(prop)) { continue; }
                formData.append(prop, postData[prop]);
              }
              this.iatchSrvc.update(`${environment.apiUrl}/ImageAtchDet/${this.tenantId}/${this.branchId}/${labresult[0].id}`, formData).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {

                this.mylabInputVariable.nativeElement.value = "";
                this.labfileToUpload = null;
              }, (error) => {

              }, () => {
                localStorage.setItem("Lab logo", this.labsrcname);
              });

            }
          }
          else {
            if (this.labfileToUpload != null) {
              const formData: FormData = new FormData();
              formData.set('fileKey', this.labfileToUpload, this.tenantId + "." + this.labfileToUpload.name.substring(this.labfileToUpload.name.lastIndexOf('.') + 1));
              let postData: imageatch_det = {
                tenantId: this.tenantId,
                branchId: this.branchId,
                containerName: this.tenantId,
                fileLocation: `${this.branchId}/Lab logo/${this.tenantId + "." + this.labfileToUpload.name.substring(this.labfileToUpload.name.lastIndexOf('.') + 1)}`,
                fileName: this.tenantId + "." + this.labfileToUpload.name.substring(this.labfileToUpload.name.lastIndexOf('.') + 1),
                category: "Lab logo",
                createdDate: new Date(),
                createdBy: localStorage.getItem("userId"),
                isCreate: true,
                isEdit: true,
                isView: true,
              }

              for (const prop in postData) {
                if (!postData.hasOwnProperty(prop)) { continue; }
                formData.append(prop, postData[prop]);
              }

              this.iatchSrvc.create(`${this.getApiUrl}/ImageAtchDet/${this.tenantId}/${this.branchId}/atch`, formData).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
                this.mylabInputVariable.nativeElement.value = "";
                this.labfileToUpload = null;
              }, (error) => {
              }, () => {
              });

            }
          }

          let phymacyresult = data.filter(x => x.phyId == null && x.empId == null && x.patId == null && x.tenantId === this.tenantId && x.category == "Pharmacy logo")

          if (phymacyresult.length > 0) {
            if (this.pharmacyfileToUpload != null) {
              const formData: FormData = new FormData();
              formData.set('fileKey', this.pharmacyfileToUpload, this.tenantId + "." + this.pharmacyfileToUpload.name.substring(this.pharmacyfileToUpload.name.lastIndexOf('.') + 1));
              let postData: imageatch_det = {
                id:phymacyresult[0].id,
                tenantId: this.tenantId,
                branchId: this.branchId,
                containerName: this.tenantId,
                fileLocation: `${this.branchId}/Pharmacy logo/${this.tenantId + "." + this.pharmacyfileToUpload.name.substring(this.pharmacyfileToUpload.name.lastIndexOf('.') + 1)}`,
                fileName: this.tenantId + "." + this.pharmacyfileToUpload.name.substring(this.pharmacyfileToUpload.name.lastIndexOf('.') + 1),
                category: "Pharmacy logo",
                createdDate: phymacyresult[0].createdDate,
                createdBy: localStorage.getItem("userId"),
                isCreate: true,
                isEdit: true,
                isView: true,
              }

              for (const prop in postData) {
                if (!postData.hasOwnProperty(prop)) { continue; }
                formData.append(prop, postData[prop]);
              }

              this.iatchSrvc.update(`${environment.apiUrl}/ImageAtchDet/${this.tenantId}/${this.branchId}/${phymacyresult[0].id}`, formData).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {

                this.mypharmacyInputVariable.nativeElement.value = "";
                this.pharmacyfileToUpload = null;
              }, (error) => {

              }, () => {
                localStorage.setItem("Pharmacy logo", this.pharmacysrcname);
              });

            }
          }
          else {
            if (this.pharmacyfileToUpload != null) {
              const formData: FormData = new FormData();
              formData.set('fileKey', this.pharmacyfileToUpload, this.tenantId + "." + this.pharmacyfileToUpload.name.substring(this.pharmacyfileToUpload.name.lastIndexOf('.') + 1));
              let postData: imageatch_det = {
                tenantId: this.tenantId,
                branchId: this.branchId,
                containerName: this.tenantId,
                fileLocation: `${this.branchId}/Pharmacy logo/${this.tenantId + "." + this.pharmacyfileToUpload.name.substring(this.pharmacyfileToUpload.name.lastIndexOf('.') + 1)}`,
                fileName: this.tenantId + "." + this.pharmacyfileToUpload.name.substring(this.pharmacyfileToUpload.name.lastIndexOf('.') + 1),
                category: "Pharmacy logo",
                createdDate: new Date(),
                createdBy: localStorage.getItem("userId"),
                isCreate: true,
                isEdit: true,
                isView: true,
              }

              for (const prop in postData) {
                if (!postData.hasOwnProperty(prop)) { continue; }
                formData.append(prop, postData[prop]);
              }

              this.iatchSrvc.create(`${this.getApiUrl}/ImageAtchDet/${this.tenantId}/${this.branchId}/atch`, formData).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
                this.mypharmacyInputVariable.nativeElement.value = "";
                this.pharmacyfileToUpload = null;
              }, (error) => {
              }, () => {
              });

            }
          }

          let bannerresult = data.filter(x => x.phyId == null && x.empId == null && x.patId == null && x.tenantId === this.tenantId && x.category == "wallpaper")
          const formData1: FormData = new FormData();
          this.banner1fileToUpload!=null?formData1.set('fileKey', this.banner1fileToUpload, this.tenantId + "." + this.banner1fileToUpload?.name.substring(this.banner1fileToUpload?.name.lastIndexOf('.') + 1)):"";
          let postData1: imageatch_det = {
            tenantId: this.tenantId,
            branchId: this.branchId,
            containerName: this.tenantId,
            fileLocation: `wallpaper/1${this.tenantId}`,
            fileName: "1" + this.tenantId,
            category: "wallpaper",
            createdDate: new Date(),
            createdBy: localStorage.getItem("userId"),
            isCreate: true,
            isEdit: true,
            isView: true,
          }
       
          if (bannerresult.length > 0) {
            if (this.banner1fileToUpload != null) {
              postData1.createdDate = bannerresult[0].createdDate;
              for (const prop in postData1) {
                if (!postData1.hasOwnProperty(prop)) { continue; }
                formData1.append(prop, postData1[prop]);
              }
              this.iatchSrvc.update(`${environment.apiUrl}/ImageAtchDet/${this.tenantId}/${this.branchId}/${bannerresult[0].id}/updateTenantWallpaper`, formData1).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
                this.banner1fileToUpload = null;
              }, (error) => {
              }, () => {
                localStorage.setItem("banner logo1", this.bannersrcname1);
              });
            }
          }
          else {
            if (this.banner1fileToUpload != null) {
              for (const prop in postData1) {
                if (!postData1.hasOwnProperty(prop)) { continue; }
                formData1.append(prop, postData1[prop]);
              }
              this.iatchSrvc.create(`${this.getApiUrl}/ImageAtchDet/${this.tenantId}/${this.branchId}/createTenantWallpaper`, formData1).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
                this.banner1fileToUpload = null;
              }, (error) => {
              }, () => {
              });
            }
          }

          const formData2: FormData = new FormData();
          this.banner2fileToUpload!=null?formData2.set('fileKey', this.banner2fileToUpload, this.tenantId + "." + this.banner2fileToUpload?.name.substring(this.banner2fileToUpload?.name.lastIndexOf('.') + 1)):"";
          let postData2: imageatch_det = {
            tenantId: this.tenantId,
            branchId: this.branchId,
            containerName: this.tenantId,
            fileLocation: `wallpaper/2${this.tenantId}`,
            fileName: "2" + this.tenantId,
            category: "wallpaper",
            createdDate: new Date(),
            createdBy: localStorage.getItem("userId"),
            isCreate: true,
            isEdit: true,
            isView: true,
          }
         
          if (bannerresult.length > 1) {
            if (this.banner2fileToUpload != null) {
              postData2.createdDate = bannerresult[1].createdDate;
              for (const prop in postData2) {
                if (!postData2.hasOwnProperty(prop)) { continue; }
                formData2.append(prop, postData2[prop]);
              }
              this.iatchSrvc.update(`${environment.apiUrl}/ImageAtchDet/${this.tenantId}/${this.branchId}/${bannerresult[1].id}/updateTenantWallpaper`, formData2).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
                this.banner2fileToUpload = null;
              }, (error) => {
              }, () => {
                localStorage.setItem("banner logo2", this.bannersrcname2);
              });
            }
          }
          else {
            if (this.banner2fileToUpload != null) {
              for (const prop in postData2) {
                if (!postData2.hasOwnProperty(prop)) { continue; }
                formData2.append(prop, postData2[prop]);
              }
              this.iatchSrvc.create(`${this.getApiUrl}/ImageAtchDet/${this.tenantId}/${this.branchId}/createTenantWallpaper`, formData2).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
                this.banner2fileToUpload = null;
              }, (error) => {
              }, () => {
              });
            }
          }

          const formData3: FormData = new FormData();
          this.banner3fileToUpload!=null?formData3.set('fileKey', this.banner3fileToUpload, this.tenantId + "." + this.banner3fileToUpload?.name.substring(this.banner3fileToUpload?.name.lastIndexOf('.') + 1)):"";
          let postData3: imageatch_det = {
            tenantId: this.tenantId,
            branchId: this.branchId,
            containerName: this.tenantId,
            fileLocation: `wallpaper/3${this.tenantId}`,
            fileName: "3" + this.tenantId,
            category: "wallpaper",
            createdDate: new Date(),
            createdBy: localStorage.getItem("userId"),
            isCreate: true,
            isEdit: true,
            isView: true,
          }
         

          if (bannerresult.length > 2) {
            if (this.banner3fileToUpload != null) {
                postData3.createdDate = bannerresult[2].createdDate;
                for (const prop in postData3) {
                  if (!postData3.hasOwnProperty(prop)) { continue; }
                  formData3.append(prop, postData3[prop]);
                }
                this.iatchSrvc.update(`${environment.apiUrl}/ImageAtchDet/${this.tenantId}/${this.branchId}/${bannerresult[2].id}/updateTenantWallpaper`, formData3).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
                this.banner3fileToUpload = null;
              }, (error) => {
              }, () => {
                localStorage.setItem("banner logo3", this.bannersrcname3);
              });
            }
          }
          else {
            if (this.banner3fileToUpload != null) {
              for (const prop in postData3) {
                if (!postData3.hasOwnProperty(prop)) { continue; }
                formData3.append(prop, postData3[prop]);
              }
                this.iatchSrvc.create(`${this.getApiUrl}/ImageAtchDet/${this.tenantId}/${this.branchId}/createTenantWallpaper`, formData3).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
                this.banner3fileToUpload = null;
              }, (error) => {
              }, () => {
              });
            }
          }



        }, (error) => {

        }, () => {

        });

      }, (error) => {

      }, () => {
        this.isEdit = true;
        setTimeout(() => {
          this.isEdit = false;
        }, 5000);
        this.dataEvent.emit([this.newTenantEdit, 'save']);

      });
    }


  }
  get getApiUrl(): string {
    return environment.apiUrl;
  }


  onSave(): void {
    if (this.tenantEditForm.valid) {
      this.newTenantData = {
        name: this.tenantEditForm.get('newtenantName').value,
        phoneNum: this.tenantEditForm.get('newContNum').value,
        emailAddr: this.tenantEditForm.get('newEmail').value,
        city: this.tenantEditForm.get('newCity').value,
        area: this.tenantEditForm.get('area').value,
        district: "",
        street: this.tenantEditForm.get('street').value,
        state: this.tenantEditForm.get('newState').value,
        country: this.tenantEditForm.get('newCtry').value,
        pincode: this.tenantEditForm.get('newPinCode').value,
        other_AddPHNO: this.tenantEditForm.get('newAltPh').value,
        tenantUserId: this.tenantEditForm.get('tenantUserId').value,
        noOfLicences: this.tenantEditForm.get('noOfLicence').value,
        emailVerification: this.editTenantDetails.emailVerification,
        mobileVerification: this.editTenantDetails.mobileVerification,
        noOfBranch: this.tenantEditForm.get('noOfBranch').value,
        smsActivationFlag: this.smsActivationFlag,
        whatsAppActivationFlag: this.whatsappActivationFlag,
        mailActivationFlag: this.mailActivationFlag,

        sourceUrl: null,
        hideLabel: null,
        storageProvider:this.storageProviderData,
        controlCenter:this.editTenantDetails?.controlCenter,
        superAdminController:this.editTenantDetails?.superAdminController,
        tenantCountryCode: this.editTenantDetails?.tenantCountryCode,
      };
      this.tenantSrvc.create(`${this.apiUrl}/tenants/${this.tenantId}/tenantmst`, this.newTenantData).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      }, (error) => {
      }, () => {
        this.isAddComponent = false;
        this.fetchTenant();
      });
    }
    else
      return;
  }

  get apiUrl(): string {
    return environment.apiUrl;
  }
  ngOnDestroy(): void {
    this.unsubscribe$.unsubscribe();
  }

  onClear(): void {
    this.isAddComponent = false;
    this.isEditComponent = false;
    this.dataEvent.emit([this.newTenantEdit, 'close']);

  }

  handleFileInput(files: any, type: string) {
    if(files.target.files[0].size>5000000){
      this.fileSizeError=true;
      return;
    }
    this.fileSizeError=false;
    if (type == "tenant") {
      if (files.currentTarget.files.length > 0) {
        this.fileToUpload = files.currentTarget.files[0];
        const file = files.target.files[0];

        const reader = new FileReader();
        reader.onload = e => {
          this.srcname = reader.result;

          this.tenantLogo = this.srcname;
        }
        reader.readAsDataURL(file);
      }
    }
    else if (type == "lab") {
      if (files.currentTarget.files.length > 0) {
        this.labfileToUpload = files.currentTarget.files[0];
        const file = files.target.files[0];
        const reader = new FileReader();
        reader.onload = e => this.labsrcname = reader.result;
        reader.readAsDataURL(file);
      }
    }
    else if (type == "pharmacy") {
      if (files.currentTarget.files.length > 0) {
        this.pharmacyfileToUpload = files.currentTarget.files[0];
        const file = files.target.files[0];
        const reader = new FileReader();
        reader.onload = e => this.pharmacysrcname = reader.result;
        reader.readAsDataURL(file);
      }
    } else if (type == "banner1") {  
      if (files.currentTarget.files.length > 0) {
        this.banner1fileToUpload = files.currentTarget.files[0];
        const file = files.target.files[0];
        const reader = new FileReader();
        reader.onload = e => this.bannersrcname1 = reader.result;
        reader.readAsDataURL(file);
      }
    } else if (type == "banner2") {
      if (files.currentTarget.files.length > 0) {
        this.banner2fileToUpload = files.currentTarget.files[0];
        const file = files.target.files[0];
        const reader = new FileReader();
        reader.onload = e => this.bannersrcname2 = reader.result;
        reader.readAsDataURL(file);
      }
    } else if (type == "banner3") {
      if (files.currentTarget.files.length > 0) {
        this.banner3fileToUpload = files.currentTarget.files[0];
        const file = files.target.files[0];
        const reader = new FileReader();
        reader.onload = e => this.bannersrcname3 = reader.result;
        reader.readAsDataURL(file);
      }
    }


  }

  sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  async smspurchaseYes() {
    await this.sleep(10);
    if (document.getElementById("smsYes")?.getAttribute("class") != "p-f-wrap selected") {
      document.getElementById("smsYes")?.setAttribute("class", "p-f-wrap selected");
      document.getElementById("smsNo")?.setAttribute("class", "p-f-wrap");
    }
    this.smsActivationFlag = true;
  }

  async smspurchaseNo() {
    await this.sleep(10);
    if (document.getElementById("smsNo").getAttribute("class") != "p-f-wrap selected") {
      document.getElementById("smsNo").setAttribute("class", "p-f-wrap selected");
      document.getElementById("smsYes").setAttribute("class", "p-f-wrap");
    }
    this.smsActivationFlag = false;
  }

  async whatsapppurchaseYes() {
    await this.sleep(10);
    if (document.getElementById("whatsappYes").getAttribute("class") != "p-f-wrap selected") {
      document.getElementById("whatsappYes").setAttribute("class", "p-f-wrap selected");
      document.getElementById("whatsappNo").setAttribute("class", "p-f-wrap");
    }
    this.whatsappActivationFlag = true;
  }

  async whatsapppurchaseNo() {
    await this.sleep(10);
    if (document.getElementById("whatsappNo").getAttribute("class") != "p-f-wrap selected") {
      document.getElementById("whatsappNo").setAttribute("class", "p-f-wrap selected");
      document.getElementById("whatsappYes").setAttribute("class", "p-f-wrap");
    }
    this.whatsappActivationFlag = false;
  }

  async mailpurchaseYes(){
    await this.sleep(10);
    if (document.getElementById("mailYes").getAttribute("class") != "p-f-wrap selected") {
      document.getElementById("mailYes").setAttribute("class", "p-f-wrap selected");
      document.getElementById("mailNo").setAttribute("class", "p-f-wrap");
    }
    this.mailActivationFlag = true;
  }

  async mailpurchaseNo(){
    await this.sleep(10);
    if (document.getElementById("mailNo").getAttribute("class") != "p-f-wrap selected") {
      document.getElementById("mailNo").setAttribute("class", "p-f-wrap selected");
      document.getElementById("mailYes").setAttribute("class", "p-f-wrap");
    }
    this.mailActivationFlag = false;
  }
}
export function mobileAndAltMobileValidator(mobile: string, altMobile: string): ValidationErrors | null {
  return (group: FormGroup) => {
    let mobileInput = group.controls[mobile];
    let altMobileInput = group.controls[altMobile];
    if (mobileInput.value === altMobileInput.value) {
      return { equivalent: true }
    }
    else {
      return null
    }
  }
}






